document.addEventListener("DOMContentLoaded", function () {
  //New Mobile Experience for Featured Collections
  let featuredCollectionsMobileSliders = document.querySelectorAll(
    ".homepage--featured-collections.mobile-slider"
  );

  featuredCollectionsMobileSliders.forEach(function (mobileSlider) {
    new Swiper(mobileSlider.querySelector(".swiper"), {
      slidesPerView: 2.3,
      spaceBetween: 10,
    });
  });
});

document.addEventListener("DOMContentLoaded", function(){
  new Swiper(document.querySelector(".homepage--hero-new .swiper"), {
    slidesPerView: 1,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    }
  });
});
//New Announcement Banner
document.addEventListener("DOMContentLoaded", function () {
  let announcementBanner = document.querySelector(".header__announcement");
  if (!announcementBanner) return;
  let announcementBannerText = document.querySelectorAll(
    ".header__announcement-text"
  );

  function startSlidingAnimations() {
    let activeAnnouncementText = document.querySelector(
      ".header__announcement-slider .header__announcement-text[data-announcement-active='true']"
    );
    let nextAnnouncement =
      activeAnnouncementText.nextElementSibling ??
      document.querySelector(
        ".header__announcement-slider .header__announcement-text"
      );

        activeAnnouncementText.style.zIndex = "-1";

    activeAnnouncementText.style.opacity = "0";
    activeAnnouncementText.style.transform = "translateY(-10px)";
  activeAnnouncementText.removeAttribute("data-announcement-active");

    nextAnnouncement.style.zIndex = "";

    nextAnnouncement.style.opacity = "1";
    nextAnnouncement.style.transform = "translateY(0px)";
    nextAnnouncement.setAttribute("data-announcement-active", "true");
  }
  if (announcementBanner.classList.contains("header__announcement-slider")) {
    announcementBannerText.forEach(function (announcementText) {
      if (announcementText.getAttribute("data-announcement-active")) {
        announcementText.style.opacity = "1";
        announcementText.style.transform = "translateY(0px)";
        announcementText.style.zIndex = "";
        
      } else {
    announcementText.style.zIndex = "-1";
                announcementText.style.opacity = "0";
        announcementText.style.transform = "translateY(-10px)";
      }
      announcementText.style.display = "";
    });

    if (announcementBannerText.length > 1) {
      setInterval(function () {
        startSlidingAnimations();
      }, announcementBanner.getAttribute("data-announcement-duration") * 1000);
    }
  } else if (
    announcementBanner.classList.contains("header__announcement-scroll")
  ) {
  announcementBanner.addEventListener('mouseover', function () {
  announcementBanner.classList.add('paused');
});
announcementBanner.addEventListener('mouseleave', function () {
  announcementBanner.classList.remove('paused');
});

const initialContent = announcementBanner.innerHTML;
announcementBanner.insertAdjacentHTML('beforeend', initialContent); // Duplicate initially once

const scrollSpeed = 1;

function autoScrollRight() {
  if (announcementBanner.classList.contains('paused')) {
    requestAnimationFrame(autoScrollRight);
    return;
  }

  announcementBanner.scrollLeft += scrollSpeed;

  const halfWidth = announcementBanner.scrollWidth / 2;

  if (announcementBanner.scrollLeft >= halfWidth) {
    // Seamlessly reset scroll position by half total width
    announcementBanner.scrollLeft -= halfWidth;
  }

  requestAnimationFrame(autoScrollRight);
}

autoScrollRight();

  }
});
